<template>
	<span ref="contactRef"></span>
	<section
		class="section section--compact contact"
		v-if="model.name || model.address || model.email || model.phone"
	>
		<div class="section__inner">
			<div class="grid-spaceBetween">
				<div class="col-auto">
					<h2 class="body-text--small bold">
						{{ dataProps.responsiblelabel }}
					</h2>
				</div>
				<div class="col-auto">
					<span class="contact__name">{{ model.name }}</span>
					<span class="contact__address">{{ formattedAddress }}</span>
					<span
						class="contact__phonenumber"
						v-if="model.phone.length"
					>
						<a :href="'tel:' + model.phone" class="inline-link">
							{{ formattedPhoneNumber }}
						</a>
					</span>
				</div>

				<div class="col-auto">
					<div class="grid-noGutter">
						<div class="col-auto" v-if="model.email.length">
							<a
								:href="'mailto:' + model.email"
								class="inline-link"
								>{{ dataProps.sendmaillabel }}</a
							>
						</div>
						<div class="col-auto" v-if="model.email.length">
							<span class="horizontal-divider"></span>
						</div>
						<div class="col-auto">
							<a
								:href="digitalPostLink"
								class="inline-link"
								target="_blank"
								>{{ dataProps.digitalpostlabel }}</a
							>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script setup>
import { ref, onMounted, computed } from "vue";
import axios from "axios";

const model = ref({
	name: null,
	address: null,
	digitalPostBusiness: false,
	email: null,
	phone: null,
});

const loading = ref(false);
const dataProps = ref({});
const apiurl = ref("");

const contactRef = ref("contactRef");

onMounted(() => {
	dataProps.value = contactRef.value?.parentElement?.dataset;
	if (dataProps.value) {
		apiurl.value = dataProps.value.apiurl;
	}
	fetchData();
});

const fetchData = async () => {
	loading.value = true;
	try {
		let response = await axios.get(apiurl.value, {
			params: {
				ContentId: dataProps.value.contentid,
			},
		});

		if (response.status == 200 && response.data) {
			model.value = Object.assign({}, model.value, response.data);
		}
		loading.value = false;
		return response;
	} catch (err) {
		console.warn(err);
		loading.value = false;
		return false;
	}
};

const digitalPostLink = computed(() => {
	if (model.value.digitalPostBusiness) {
		return "https://virk.dk/digitalpost/new/c5ddcfc3-3db8-4fb6-83cc-10d2468955c6/fd422fce-7d2d-464f-9773-211b3183f3b3/";
	} else {
		return "https://post.borger.dk/send/c5ddcfc3-3db8-4fb6-83cc-10d2468955c6/fd422fce-7d2d-464f-9773-211b3183f3b3/";
	}
});

const formattedPhoneNumber = computed(() => {
	return model.value.phone?.replace(
		/(\d{2})(\d{2})(\d{2})(\d{2})/,
		"$1 $2 $3 $4"
	);
});

const formattedAddress = computed(() => {
	return model.value.address?.replace("<br />", ",");
});
</script>
